import {GentelellaModalBodyComponent} from "./modal-body.component";
import {GentelellaModalFooterComponent} from "./modal-footer.component";
import {GentelellaModalHeaderComponent} from "./modal-header.component";
import {GentelellaModalContainerComponent} from "./modal-container.component";
import {ModalService} from "./modal.service";

export const MODAL_POPUP_COMPONENTS = [
    GentelellaModalContainerComponent,
    GentelellaModalHeaderComponent,
    GentelellaModalFooterComponent,
    GentelellaModalBodyComponent
];

export const MODAL_POPUP_PROVIDERS = [
    ModalService
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/modal/index.ts